import React, {useState, useEffect} from 'react'
import {Container, Row} from 'react-bootstrap'
import Judul from 'components/dashboard/dashcomp/judul'
import CardProduk from 'components/dashboard/dashcomp/card_produk'
import axios from 'axios';
import { API_URL } from 'api';
import { access_token } from 'token';
import { useHistory } from 'react-router'

export default function Produk_terbaru() {
    const [datas, setData] = useState([])
    const [requesError, setRequesError] = useState()

    const history = useHistory()
    const masukKeranjang = (value) => {
        // console.log("menu ", Produk[value])
        history.push('/product')
    }

    console.log(datas)

    async function getData(){
        try{
            const response = await axios.get(`${API_URL}/api/reseller/homepage/product/new`)
            setData(response.data.data[0].data.sub_data)
        } catch (err) {
            setRequesError(err.message)
        }
    }

    useEffect(() => {
        getData()
    }, [])

    axios.interceptors.request.use(
        config => {
            config.headers.authorization = `bearer ${access_token}`;
            return config
        },
        error => {
            return Promise.reject(error)
        }
    )

   // ingat dadalam row tepatnya di tag CardProduk ada mapingnya, tunggu data lebih dari 1.baru pasangkan mapnya
 

    return (
        <Container className="mt-5">
            <Judul judul="Produk Terbaru" />
            <Row>

                <CardProduk 
                onClick={() => masukKeranjang()}
                header={datas.commision_rp}
                src={`asset/dashboard/produk/img-1.png`} 
                alt="produk"
                text={datas.title} potongan={datas.discount}
                price={datas.catalog_price}
                />

                {requesError && <p>{requesError}</p>}
            </Row>
        </Container>
    )
}


// const NewProduk = [
//     {src:"img-", header:"Komisi 15%", text:"Sensi Duckbill Original / Sensi Mask Duckbill ...", potongan:"Rp. 137.000", price:"Rp. 100.000", shere:"Bagikan Produk"},
//     {src:"img-", header:"Komisi 10%", text:"Alquran Hafalan Terjemah Tajwid Warna", potongan:"Rp. 95.000", price:"Rp. 73.000", shere:"Bagikan Produk"},
//     {src:"img-", header:"Komisi 15%", text:"Kurma Tunisia Tangkai Timur Tengah ...", potongan:"Rp. 48.500", price:"Rp. 30.000", shere:"Bagikan Produk"},
//     {src:"img-", header:"Komisi 15%", text:"Kurma Sukari Al Qosim 500 gram", potongan:"Rp. 48.500", price:"Rp. 30.000", shere:"Bagikan Produk"},
//     {src:"img-", header:"Komisi Rp.5000", text:"Bahasa Indonesia SMP Kelas 7 K13 Revisi ...", potongan:"Rp. 75.000", price:"Rp. 70.000", shere:"Bagikan Produk"},
//     {src:"img-", header:"Komisi 10%", text:"Kitab Riyadush Shalihin karya Imam An Nawawi", potongan:"Rp. 160.000", price:"Rp. 120.000", shere:"Bagikan Produk"}
// ]
